import React, {
    createContext,
} from "react";

export const LayoutBodyContext = createContext<React.RefObject<HTMLDivElement> | null>(null);
